import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/relatorio-estatistico-atendimento`

    return {
        index() {
            return repository.get(`${baseUrl}`);
        },
        list(params) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(params)}`)
        },
        search(params) {
            return repository.get(`${baseUrl}/search?${urlUtil.serialize(params)}`)
        },
    }
}
